<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="transfer">
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                    <h4 class="modal-title">{{ $t('transfer') }}</h4>
                </div>
                <div class="modal-body">
                    <div class="modal_deal p_bottom_15">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="alert alert_default t_center">
                                    <label class="show bold"><i class="fa fa-exclamation-triangle"></i> {{ $t('heads_up') }}!</label>
                                    {{ $t('transfer_deals_alert') }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 m_bottom_15" :class="{'has-error': errors['member_id']}">
                                <label>{{ $t('consultant') }}</label>
                                <pml-select v-model="member_id" :options="members" label="full_name"></pml-select>
                                <span class="error" v-if="errors['member_id']">{{ errors['member_id'] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-15 clearfix">
                    <button type="button" class="btn btn-white" @click="goBack()">{{ $t('cancel') }}</button>
                    <button type="submit" class="btn btn-default pull-right" :disabled="member_id === ''">{{ $t('transfer') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import RoutedModals from '@/utils/mixins/routed-modals'
    import bus from '@/utils/events/bus'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'DealsTransfer',
        mixins: [ RoutedModals ],
        data () {
            return {
                goBackTo: '/deals',
                member_id: '',
                errors: []
            }
        },
        metaInfo () {
            return {
                title: trans('transfer')
            }
        },
        computed: {
            ...mapGetters({
                'members': 'getMembers'
            })
        },
        methods: {
            transfer () {
                bus.$emit('transferDeals', this.member_id)
                this.goBack()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/list/Transfer.vue